module.exports = __webpack_public_path__ + "static/media/motion_background.d90d7e16.mp4";